import React, { useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import PropTypes from 'prop-types'
import { remove } from 'lodash'
import { CardContent, Grid, TextField } from '@material-ui/core'

import { BasePhoneInput } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'
import useAuth from 'hooks/useAuth'

import schemaUser from './schema'
import * as service from 'service'
import constants from 'constants/index'

const UsersForm = ({
  user,
  setLoading,
  loadData,
  formId,
  formIds,
  setFormIds,
  setHasPhone,
}) => {
  const { DEFAULT_DDI } = constants.countries

  const auth = useAuth()
  const snackbar = useSnackbar()

  const { control, handleSubmit, errors, reset, getValues, formState, watch } =
    useForm({
      validationSchema: schemaUser(auth?.userCompany?.responsable),
      defaultValues: {
        name: user?.name ?? '',
        email: user?.email ?? '',
        phone: user?.phone || DEFAULT_DDI,
      },
    })

  const phone = watch('phone')

  const onSubmit = async (userFormData) => {
    try {
      setLoading(true)
      await service.dponet.users.editSelf({ ...userFormData })
      if (formIds.length === 1) {
        await loadData()
        snackbar.open({
          message: 'Seus dados foram atualizado com sucesso',
          variant: 'success',
        })
      }
    } catch (error) {
      reset(getValues())
      snackbar.open({
        message: helpers.formatters.errorMessage(error.response.data.error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (formState.dirty) {
      setFormIds([formId, ...formIds])
    } else {
      remove(formIds, (item) => item?.id === formId?.id)
      setFormIds([...formIds])
    }

    //eslint-disable-next-line
  }, [formState.dirty])

  useEffect(() => {
    if (helpers.validates.phone.schema({ value: phone, required: true }))
      setHasPhone(true)
    else setHasPhone(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phone])

  return (
    <CardContent>
      <form
        ref={(form) => [(formId = form)]}
        onSubmit={handleSubmit(onSubmit)}
        id={formId}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Controller
              as={
                <TextField
                  label="Nome"
                  type="text"
                  color="primary"
                  variant="outlined"
                  error={!!errors.name}
                  helperText={errors?.name?.message}
                  fullWidth
                />
              }
              control={control}
              name="name"
              mode="onChange"
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              as={
                <TextField
                  label="Email"
                  type="email"
                  color="primary"
                  variant="outlined"
                  error={!!errors.email}
                  helperText={errors?.email?.message}
                  fullWidth
                />
              }
              control={control}
              name="email"
              mode="onBlur"
            />
          </Grid>
          {auth?.userCompany?.responsable && (
            <Grid item xs={12}>
              <Controller
                as={
                  <BasePhoneInput
                    label="Telefone"
                    error={!!errors.phone}
                    helperText={errors?.phone?.message}
                    fullWidth
                  />
                }
                control={control}
                name="phone"
                mode="onChange"
              />
            </Grid>
          )}
        </Grid>
      </form>
    </CardContent>
  )
}

UsersForm.propTypes = {
  user: PropTypes.object,
  setLoading: PropTypes.func,
  loadData: PropTypes.func,
  formId: PropTypes.string,
  formIds: PropTypes.array,
  setFormIds: PropTypes.func,
}

export default UsersForm
